/**
 * Session countdown for the cart-drawer hold bar.
 * Visual only. Does not hold stock or a checkout.
 */
const HOLD_MS = 10 * 60 * 1000;
const KEY = 'tb-cart-hold-until';

const pad = (n) => String(n).padStart(2, '0');

function untilMs() {
  const now = Date.now();
  let until = Number(sessionStorage.getItem(KEY));
  if (!Number.isFinite(until) || until <= now) {
    until = now + HOLD_MS;
    try {
      sessionStorage.setItem(KEY, String(until));
    } catch (err) {
      /* private mode */
    }
  }
  return until;
}

function paint() {
  const clocks = document.querySelectorAll('[data-tb-hold-clock]');
  if (!clocks.length) return;
  const left = Math.max(0, Math.ceil((untilMs() - Date.now()) / 1000));
  const label = `${pad(Math.floor(left / 60))}:${pad(left % 60)}`;
  clocks.forEach((el) => {
    el.textContent = label;
  });
}

paint();
window.setInterval(paint, 1000);
